import React, { Component } from 'react';
import Grid from '@material-ui/core/Grid';
import PropTypes from 'prop-types';
import ControversyIndex from './ControversyIndex';
import { 
    EMOTION_AND_INTENSITY_LABEL,
    HEATED_COMMENTS_PERCENTAGE_LABEL,
    TOXIC_COMMENTS_PERCENTAGE_LABEL,
    NONE_FEED_EMOTION_CATEGORY,
    EMOTION_TO_EMOTION_SCORE_MAP,
    PERCENTAGE_LABEL
} from './constants';
import { NO_SPECIFIC_EMOTION } from '../../home/redux/constants';

export class ControversyIndicesGrid extends Component {

    static propTypes = {
        feed: PropTypes.object.isRequired
    }
  
    constructor(props) {
        super(props);
    }

    _returnPostEmotionAndIntensityValue() {
        let currentFeed = this.props.feed;
        let feedEmotionCategory = currentFeed.emotionValues.emotion_category;
        if (!feedEmotionCategory || feedEmotionCategory === NONE_FEED_EMOTION_CATEGORY) {
            return NONE_FEED_EMOTION_CATEGORY;
        }
        let postEmotionAndIntensityValue = feedEmotionCategory.charAt(0).toUpperCase() + feedEmotionCategory.slice(1);
        if (feedEmotionCategory === NO_SPECIFIC_EMOTION) {
            return postEmotionAndIntensityValue;
        }
        else {
            let emotionScoreKey = EMOTION_TO_EMOTION_SCORE_MAP[feedEmotionCategory];
            let emotionScore = currentFeed.emotionValues[emotionScoreKey];
            postEmotionAndIntensityValue += " | " + String(emotionScore);
        }
        return postEmotionAndIntensityValue;
    }

    _returnValueWithPercentageSign(value) {
        return String(value) + PERCENTAGE_LABEL;
    }

    render() {
        let postEmotionAndIntensityValue  = this._returnPostEmotionAndIntensityValue();
        let heatedCommentsPercentageValue = this._returnValueWithPercentageSign(this.props.feed.percentageOfHeatedComments);
        let toxicCommentsPercentageValue  = this._returnValueWithPercentageSign(this.props.feed.percentageOfToxicComments);
        return (
            <div className='controversy-indices-card'>
                <span className="controversy-index-title">
                    Overall emotion for the post
                </span>
                <Grid container spacing={2}>
                    <Grid item xs={6}>
                        <ControversyIndex 
                            indexLabel={EMOTION_AND_INTENSITY_LABEL}
                            indexValue={postEmotionAndIntensityValue}
                        />
                    </Grid>
                    <Grid item xs={6}>
                        <ControversyIndex 
                            indexLabel={HEATED_COMMENTS_PERCENTAGE_LABEL}
                            indexValue={heatedCommentsPercentageValue}
                        />
                    </Grid>
                    <Grid item xs={6}>
                        <ControversyIndex 
                            indexLabel={TOXIC_COMMENTS_PERCENTAGE_LABEL}
                            indexValue={toxicCommentsPercentageValue}
                        />
                    </Grid>
                </Grid>
            </div>
        );
    }
}

  export default ControversyIndicesGrid;


// WEBPACK FOOTER //
// ./src/features/harmwatch/components/ControversyIndicesGrid.js